import {
    IProps,
} from './types';

import classNames from 'classnames';
import React, {
    FC,
} from 'react';

import {
    chooseFiles,
} from 'helpers/functions';

import {
    ErrorMessage,
} from 'components/other';

import styles from './FileInput.module.scss';

const FileInput: FC<IProps> = (props) => {
    const onClick = async () => {
        if (props.isDisabled) {
            return;
        }

        const [file] = await chooseFiles(['svg'], false);

        if (!file) {
            return;
        }

        props.onChangeValue(file);
    };

    return (
        <div
            className={
                classNames(styles.fileInput, props.className, {
                    [styles.isDisabled]: props.isDisabled,
                    [styles.isError]: props.isError,
                })
            }
        >
            {
                props.label &&
                <div className={styles.label}>
                    {props.label}
                </div>
            }
            <div
                className={styles.input}
                onClick={onClick}
            >
                Click to upload
            </div>
            <ErrorMessage
                className={styles.errorMessage}
                text={props.errorMessage ?? ''}
            />
        </div>
    );
};

export default FileInput;
